import { createStore } from "vuex"
import axios from "axios";
import router from "@/router";

export default createStore({
    state: {
        token: '',
        isAuthenticated: false,
        userId: '',
        gameId: '',
        unlockedNodes: [],
        currentPlayedScenarioId: '',
        currentPlayedGameName: "",
        currentPlayedGameTheme: "",
        startDateTime : {},
        stopDateTime : {}
    },

    mutations: {
        initializeStore(state) {
            if (localStorage.getItem('token')) {
                state.token = JSON.parse(localStorage.getItem('token'))
                state.isAuthenticated = true
                axios.defaults.headers.common['Authorization'] = "Bearer " + state.token.access
                state.userId = localStorage.getItem('userId')

            } else {
                state.token = ''
                state.isAuthenticated = false
            }

            try {
                state.unlockedNodes = JSON.parse(localStorage.getItem('unlockedNodes') ?? "[]")
                state.startDateTime = JSON.parse(localStorage.getItem('startDateTime') ?? "{}");
                state.stopDateTime = JSON.parse(localStorage.getItem('stopDateTime') ?? "{}");
            } catch (e) {
                state.unlockedNodes = "[]"
                state.startDateTime = {}
                state.stopDateTime = {}
            }
            state.currentPlayedScenarioId = localStorage.getItem('currentPlayedScenarioId') ?? ''
            state.currentPlayedGameName = localStorage.getItem('currentPlayedGameName') ?? {}
        },
        startTimer(state, params) {
            const {scenarioId, deleteHistory} = params;

            if(!state.startDateTime[scenarioId] || deleteHistory){
                state.startDateTime[scenarioId] =  Date.now()
                delete state.stopDateTime[scenarioId]
                localStorage.setItem("startDateTime", JSON.stringify(state.startDateTime))
                localStorage.setItem("stopDateTime", JSON.stringify(state.stopDateTime))
            }
        },

        addTimePenalty(state, scenarioId) { //slug
            if(state.startDateTime[scenarioId]) {
                state.startDateTime[scenarioId] =  Number(state.startDateTime[scenarioId]) - 60000;
                localStorage.setItem("startDateTime", JSON.stringify(state.startDateTime))
            }
        },
        stopTimer(state, scenarioId) { //slug
            if(!state.stopDateTime[scenarioId]) { //on ne stoppe que la premiere fois
                state.stopDateTime[scenarioId] =  Date.now();
                localStorage.setItem("stopDateTime", JSON.stringify(state.stopDateTime))
            }
        },

        setToken(state, token) {
            state.token = token
            state.isAuthenticated = true
            axios.defaults.headers.common['Authorization'] = "Bearer " + token.access
            localStorage.setItem("token", JSON.stringify(token))
        },
        removeToken(state) {
            state.token = ''
            state.isAuthenticated = false
            delete axios.defaults.headers.common['Authorization']
            localStorage.removeItem('token')
        },
        setUserId(state, userId) {
            state.userId = userId
            localStorage.setItem('userId', userId)
        },
        removeUserId(state) {
            state.userId = ''
            localStorage.removeItem('userId')
        },

        unlockNode(state, node) {
            var nodeExist = false;
            for (var i = 0; i < state.unlockedNodes.length; i++) {
                if (node.id == state.unlockedNodes[i].id) {
                    nodeExist = true
                    break;
                }
            }
            if (nodeExist == false) {
                state.unlockedNodes.push(node)
                localStorage.setItem('unlockedNodes', JSON.stringify(state.unlockedNodes))
            }
        },
        setNodeRead(state, node) {
            const nodeIndex = state.unlockedNodes.findIndex(n => n.id === node.id)
            node.new = false
            state.unlockedNodes[nodeIndex] = node
            localStorage.setItem('unlockedNodes', JSON.stringify(state.unlockedNodes));
        },

        setNodeResolved(state, node) {
            const nodeIndex = state.unlockedNodes.findIndex(n => n.id === node.id)
            node.resolved = true
            state.unlockedNodes[nodeIndex] = node
            localStorage.setItem('unlockedNodes', JSON.stringify(state.unlockedNodes));
        },

        setNodeInfo(state, node) {
            const nodeIndex = state.unlockedNodes.findIndex(n => n.id === node.id)
            node.info = true
            state.unlockedNodes[nodeIndex] = node
            localStorage.setItem('unlockedNodes', JSON.stringify(state.unlockedNodes));
        },

        emptyUnlockedNodes(state) {
            state.unlockedNodes = []
            localStorage.removeItem('unlockedNodes')
        },

        setCurrentPlayedScenarioId(state, scenarioId) {
            state.currentPlayedScenarioId = scenarioId
            localStorage.setItem('currentPlayedScenarioId', scenarioId)
        },

        setCurrentPlayedGameName(state, gameName) {
            state.currentPlayedGameName = gameName
            localStorage.setItem('currentPlayedGameName', gameName)
        },

        setCurrentPlayedGameTheme(state, theme) {
            state.currentPlayedGameTheme = theme
            localStorage.setItem('currentPlayedGameName', theme)
        },

    },

    actions: {
        logout(context) {
            context.commit('removeToken')
            context.commit('removeUserId')
            // alert("Vous avez été deconnecté.e")
            router.push({ name: 'WelcomePage' })
        },
    },
    modules: {

    }
})
